module.exports = require('sodium-native')
